import { render } from "./FormProveedor.vue?vue&type=template&id=d67fb9e4"
import script from "./FormProveedor.vue?vue&type=script&lang=js"
export * from "./FormProveedor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__